import React from 'react';
import { initiateReconnect } from 'flow/api-clients/meeting-supervisor';
import Loading from 'flow/components/ui-components/Loading';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import {
    selectVideoErrorReconnectOnClick,
    selectVideoErrorShow,
    selectVideoErrorSpinner,
    selectVideoErrorText,
} from 'flow/selectors/meeting-selectors';

const MeetingError = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const show = useAppSelector(selectVideoErrorShow);
    const reconnectOnClick = useAppSelector(selectVideoErrorReconnectOnClick);

    if (!show) {
        return null;
    }

    const triggerReconnect = async () => {
        await dispatch(initiateReconnect());
    };

    return (
        <div className="pointer-events-none absolute z-12 box-border flex h-full w-full items-center justify-center pb-25">
            {reconnectOnClick ? (
                <button
                    className="pointer-events-auto z-25 m-3 flex cursor-pointer items-center justify-between rounded-lg border-none bg-gray-700 p-4.5 text-base font-normal text-white"
                    onClick={triggerReconnect}
                    aria-label={i18next.t('meeting.error.reconnect')}
                >
                    <ErrorContent />
                </button>
            ) : (
                <div className="pointer-events-auto z-25 m-3 flex items-center justify-between rounded-lg bg-gray-700 p-4.5 text-base font-normal text-white">
                    <ErrorContent />
                </div>
            )}
        </div>
    );
};

const ErrorContent = () => {
    const { i18next } = useAppContext();

    const text = useAppSelector(selectVideoErrorText);
    const spinner = useAppSelector(selectVideoErrorSpinner);

    return (
        <>
            {spinner ? (
                <Loading className="me-2" size={18} disableTimeout={true} />
            ) : null}
            {i18next.t(text)}
        </>
    );
};

export default MeetingError;
